/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProblemType = {
    Logo: 'logo',
    Algorithmic: 'algorithmic',
    Soldered: 'soldered',
    Pybricks: 'pybricks'
} as const;
export type ProblemType = typeof ProblemType[keyof typeof ProblemType];


export function instanceOfProblemType(value: any): boolean {
    for (const key in ProblemType) {
        if (Object.prototype.hasOwnProperty.call(ProblemType, key)) {
            if (ProblemType[key as keyof typeof ProblemType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProblemTypeFromJSON(json: any): ProblemType {
    return ProblemTypeFromJSONTyped(json, false);
}

export function ProblemTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProblemType {
    return json as ProblemType;
}

export function ProblemTypeToJSON(value?: ProblemType | null): any {
    return value as any;
}

export function ProblemTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ProblemType {
    return value as ProblemType;
}

